import { render, staticRenderFns } from "./zhengshu.vue?vue&type=template&id=17cb7b9d&scoped=true&"
import script from "./zhengshu.vue?vue&type=script&lang=js&"
export * from "./zhengshu.vue?vue&type=script&lang=js&"
import style0 from "./zhengshu.vue?vue&type=style&index=0&id=17cb7b9d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17cb7b9d",
  null
  
)

export default component.exports